const LINK_PANEL_MODAL_LINK_INPUT = "link-panel-input";
const LINK_SETTINGS_CHECKBOX_NEW_TAB = "link-panel-blank-checkbox";
const LINK_SETTINGS_CHECKBOX_NOREFERRER = "link-panel-noreferrer-checkbox";
const LINK_SETTINGS_CHECKBOX_NOFOLLOW = "link-panel-rel-checkbox";
const LINK_SETTINGS_CHECKBOX_SPONSORED = "link-panel-sponsored-checkbox";
export {
  LINK_PANEL_MODAL_LINK_INPUT,
  LINK_SETTINGS_CHECKBOX_NEW_TAB,
  LINK_SETTINGS_CHECKBOX_NOFOLLOW,
  LINK_SETTINGS_CHECKBOX_NOREFERRER,
  LINK_SETTINGS_CHECKBOX_SPONSORED
};
//# sourceMappingURL=data-hooks.js.map
